import { useEffect, useState } from "react";
import { Loader2, UserX } from "lucide-react";
import { Dialog, DialogContent, DialogDescription, DialogFooter, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Textarea } from "@/components/ui/textarea";

const QUICK = ["Fees too high", "Chose another school", "Location / transport", "Not responding", "Postponed to next year"];

export const hasPayments = (r) => !!(r.form_fee || r.partial_payment || r.partial_payments?.length || (r.status === "admitted" && r.payment));

export const NotInterestedDialog = ({ open, onOpenChange, receiptNo, onConfirm }) => {
  const [reason, setReason] = useState("");
  const [busy, setBusy] = useState(false);
  useEffect(() => { if (open) setReason(""); }, [open]);
  const submit = async () => { setBusy(true); await onConfirm(reason.trim()); setBusy(false); };
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-md" data-testid="not-interested-dialog">
        <DialogHeader>
          <DialogTitle className="font-display">Not interested {receiptNo ? `· ${receiptNo}` : ""}</DialogTitle>
          <DialogDescription>Follow-ups and reminders stop for this parent. You can switch the status back if they return.</DialogDescription>
        </DialogHeader>
        <div className="flex flex-wrap gap-1.5">
          {QUICK.map((q) => (
            <button key={q} type="button" onClick={() => setReason(q)} data-testid={`not-interested-quick-${q.split(" ")[0].toLowerCase()}`}
              className={`rounded-full border px-2.5 py-1 text-xs transition-colors duration-150 ${reason === q ? "border-plum-900 bg-plum-900 text-white" : "border-plum-900/15 text-slate-600 hover:bg-plum-900/5"}`}>{q}</button>
          ))}
        </div>
        <Textarea rows={3} maxLength={300} value={reason} onChange={(e) => setReason(e.target.value)} placeholder="Reason (required)"
          className="text-sm" data-testid="not-interested-reason-input" />
        <DialogFooter>
          <Button variant="outline" onClick={() => onOpenChange(false)} data-testid="not-interested-cancel-btn">Cancel</Button>
          <Button disabled={reason.trim().length < 3 || busy} onClick={submit} className="bg-slate-700 hover:bg-slate-800" data-testid="not-interested-confirm-btn">
            {busy ? <Loader2 className="mr-2 h-4 w-4 animate-spin" /> : <UserX className="mr-2 h-4 w-4" />}Mark Not Interested
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};
